import Cookies from 'js-cookie'
import SparkMD5 from 'spark-md5'
import uuidv4 from 'uuid/v4'

const localStorageAvailable = (() => {
  const test = 'xrNHnHCan25E4C6e'
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
})()

const getLocalStorageDeviceId = () => {
  let deviceId = localStorage.getItem('device-id')
  if (!deviceId) {
    deviceId = Cookies.get('device-id')
    if (!deviceId) {
      deviceId = uuidv4()
      setCookiesDeviceId(deviceId)
    }
    localStorage.setItem('device-id', deviceId)
  } else {
    setCookiesDeviceId(deviceId)
  }
  return deviceId
}

const getCookiesDeviceId = () => {
  let deviceId = Cookies.get('device-id')
  if (!deviceId) {
    deviceId = uuidv4()
    setCookiesDeviceId(deviceId)
  }
  return deviceId
}

const setCookiesDeviceId = deviceId => {
  Cookies.set('device-id', deviceId, {
    expires: new Date(Date.now() + 3650 * 24 * 3600000),
    path: '/',
  })
}

const getSerialNumber = () => {
  if (localStorageAvailable) {
    return getLocalStorageDeviceId()
  } else {
    return getCookiesDeviceId()
  }
}

const getDeviceId = () => {
  const serialNumber = SparkMD5.hash(getSerialNumber()).toUpperCase()
  if (typeof window.Hisense_GetDeviceID === 'function') {
    return 'HSV2' + serialNumber
  } else {
    return 'GNV2' + serialNumber
  }
}

const getDeviceName = () => {
  return navigator.userAgent.substring(0, 200)
}

const getDeviceType = () => {
  return typeof window.Hisense_GetDeviceID === 'function' ? 'hisense' : 'html5'
}

const getMacAddress = () => {
  if (typeof window.Hisense_GetDeviceID === 'function') {
    const mac = window
      .Hisense_GetDeviceID()
      .replace('\n', '')
      .replace('n requires an', '')
    const regex = /^([0-9a-fA-F]{2}[:-]){5}([0-9a-fA-F]{2})$/
    if (mac.length === 17 && regex.test(mac)) {
      return mac
    }
  }
  return '00:00:00:00:00:00'
}

export default {
  getId: getDeviceId,
  getName: getDeviceName,
  getType: getDeviceType,
  getMacAddress,
  getSerialNumber: () => {
    return getSerialNumber().substr(2) + '-vi'
  },
  getUuid: getSerialNumber,
}
